import { render, staticRenderFns } from "./participant-configuration.vue?vue&type=template&id=1f82f633&scoped=true&"
import script from "./participant-configuration.vue?vue&type=script&lang=js&"
export * from "./participant-configuration.vue?vue&type=script&lang=js&"
import style0 from "./participant-configuration.vue?vue&type=style&index=0&id=1f82f633&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f82f633",
  null
  
)

component.options.__file = "participant-configuration.vue"
export default component.exports